import type { ModalService } from './../../ricos-modals';
import type { Modal, Placement } from './../../ricos-types';
import type { NamedLink } from './../link/types';

import { LINK_MODAL_ID } from './constants';
import { openLinkModal } from './open-link-modal';

export const toggleLinkModal = ({
  initialValue,
  modalService,
  onSave,
  onSaveMultiple,
  onUnlink,
  referenceElement,
  placement,
  onClickOutside,
}: {
  initialValue?: NamedLink | undefined;
  modalService: ModalService;
  onSave: (linkData: NamedLink) => void;
  onUnlink: (linkData: NamedLink) => void;
  onSaveMultiple?: (links: NamedLink[]) => void;
  referenceElement?: HTMLElement | null;
  placement?: Placement;
  onClickOutside?: Modal['onClickOutside'];
}) =>
  modalService.isModalOpen(LINK_MODAL_ID)
    ? modalService.closeModal(LINK_MODAL_ID)
    : openLinkModal({
        initialValue,
        modalService,
        onSaveMultiple,
        onSave,
        onUnlink,
        referenceElement,
        placement,
        onClickOutside,
      });
